import EditReview from './edit-review-container';

export default EditReview;
